var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useField } from 'formik';
import { default as React } from 'react';
import { FormikSwitch } from '../../Components/FormikFields/FormikSwitch';
import styles from './MedicationListDefaultOverrideSection.module.css';
export function MedicationListDefaultOverrideSection(props) {
    var _a = __read(useField(props.field), 3), field = _a[0], meta = _a[1], helpers = _a[2];
    return (React.createElement("div", { className: styles.container },
        React.createElement("div", { className: styles.header },
            React.createElement("div", { className: styles.titleBlock },
                React.createElement("div", null,
                    React.createElement("span", { className: styles.title }, props.title)),
                !!props.subTitle && React.createElement("div", { className: styles.subTitle }, props.subTitle)),
            React.createElement("div", { className: styles.titleInput },
                React.createElement(FormikSwitch, { field: props.field, label: field.value ? 'Active' : 'Inactive', labelPlacement: 'start', style: { fontWeight: 'normal' } }))),
        !!props.children && !!field.value && React.createElement("div", { className: styles.body }, props.children)));
}
